<script setup lang="ts">
import {gsap} from 'gsap';

useMenuState().value = 'expanded';

const scrollContainer = ref<HTMLElement | null>(null);
// const scrollSections = ['hero-section', 'welcome-section', 'about-section', 'buy-tickets', 'plan-section'];

onMounted(() => {
  gsap.matchMedia().add('(min-width: 1025px)', () => {
    window.scrollTo(0, 0);
    window.addEventListener('resize', debounce(handleResize));
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  location.reload();
}

interface DebouncedFunction {
  (event: Event): void;
}

function debounce(func: (event: Event) => void): DebouncedFunction {
  let timer: ReturnType<typeof setTimeout>;
  return function (event: Event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}
</script>

<template>
  <NuxtLayout name="feature-page">
    <div ref="scrollContainer" class="!pt-0">
      <section id="hero-section" data-hash="hero-section">
        <BathroomsHeroSection />
      </section>

      <!-- <section id="welcome-section" data-hash="welcome-section" class="snap-section">
        <TimesTravelVipWelcomeSection />
      </section>

      <section id="about-section" data-hash="about-section" class="snap-section">
        <TimesTravelVipAboutSection />
      </section>

      <section id="buy-tickets" data-hash="times-travel-buy-tickets" class="snap-section">
        <TimesTravelVipPackages />
      </section>

      <section id="plan-section" class="snap-section" data-hash="contact-section">
        <PlanVisit />
      </section> -->

      <!-- <ScrollDownButton v-if="scrollContainer" :scroll-container="scrollContainer" :scroll-sections="scrollSections" /> -->
    </div>
  </NuxtLayout>
</template>

<style lang="scss">
@use '@/assets/scss/queries';

.snap-section {
  scroll-margin-top: var(--header-desktop-collapse-height);

  @include queries.for-size(phone) {
    scroll-margin-top: var(--header-mobile-collapse-height);
  }
}
</style>
